import { render, staticRenderFns } from "./configuration-instrumentation-devices-modal-basic-form.vue?vue&type=template&id=81f807ee&scoped=true&"
import script from "./configuration-instrumentation-devices-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-instrumentation-devices-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-instrumentation-devices-modal-basic-form.scss?vue&type=style&index=0&id=81f807ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f807ee",
  null
  
)

export default component.exports